import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';

import css from './BookingBreakdown.css';

const LineItemBasePriceMaybe = props => {
  const { transaction, unitType, userRole, intl, listing } = props;
  const isNightly = unitType === LINE_ITEM_NIGHT;
  const isDaily = unitType === LINE_ITEM_DAY;
  // The customer buys the freelancer's work; the fee and the VAT follow as
  // their own rows, as in the offer confirm step's price box.
  const translationKey =
    userRole === 'customer'
      ? 'BookingBreakdown.subTotalCustomer'
      : isNightly
      ? 'BookingBreakdown.baseUnitNight'
      : isDaily
      ? 'BookingBreakdown.baseUnitDay'
      : 'BookingBreakdown.baseUnitQuantity';

  // Find correct line-item for given unitType prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/units', or 'line-item/time'
  // These are defined in '../../util/types';
  const unitPurchase = transaction.attributes.lineItems.find(
    item => item.code === unitType && !item.reversal
  );

  const quantity = unitPurchase ? unitPurchase.quantity.toString() : null;
  const unitPrice = unitPurchase ? formatMoney(intl, unitPurchase.unitPrice) : null;
  const total = unitPurchase ? formatMoney(intl, unitPurchase.lineTotal) : null;
  const projectBudget =
    listing && listing.attributes.price ? formatMoney(intl, listing.attributes.price) : null;

  return quantity && total && !projectBudget ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id={translationKey} values={{ unitPrice, quantity }} />
      </span>
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

LineItemBasePriceMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  unitType: propTypes.bookingUnitType.isRequired,
  userRole: string,
  intl: intlShape.isRequired,
};

export default LineItemBasePriceMaybe;
